import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getTopSellingProducts } from "../../service/api_calls/ordersReports/OrderReportsAPi";
import {
  getOrderReportAvg,
  getOrderReportByCity,
  getOrderReportByType,
  getOrderSummaryAnalysis,
} from "../../service/api_calls/orderSummary/orderSummaryApi";
// import {
//   formatDaysTimePeriod,
//   transformDateRangeSalesData,
//   transformSalesData,
// } from "../../reducers/orderSummary/";
import {
  getOrderReportAvgMultiBranchApi,
  getOrderReportByCityMultiBranchApi,
  getOrderSummaryAnalysisMultiBranchApi,
  getSummaryMultiBranchApi,
} from "../../service/api_calls/multiBranchOrderAnalysis/multiBranchOrderSummaryApi";
import {
  formatDaysTimePeriod,
  transformDateRangeSalesData,
  transformDateRangeSalesDataByDay,
  transformSalesData,
} from "../orderSummary/orderSummaryHelper";

const initialState = {
  summaryCountMultiBranch: null,
  summaryCountLoader: null,

  orderSaleAmtTableMonthDataMB: null,
  orderSaleAmtTableMonthDataMBLoader: false,
  orderSaleAmtYearDataMultiBranch: null,
  orderSaleAmtYearDataMultiBranchLoader: false,

  orderReportByCityMB: null,
  orderReportByCityMBLoader: false,

  topSellingProducts: null,
  topSellingProductsLoader: false,

  orderSalesByTypeYear: null,
  orderSalesByTypeYearLoader: false,

  orderReportAvgMB: null,
  orderReportAvgMBLoader: false,

  orderReportByDaysMB: null,
  orderReportByDaysMBLoader: false,
};

export const getSummaryMultiBranch = createAsyncThunk(
  "getSummaryMultiBranch",
  async (param, thunkAPI) => {
    const res = await getSummaryMultiBranchApi(param);
    console.log("getSummaryMultiBranch", res);
    return res;
  }
);

export const getTopSellingProductsData = createAsyncThunk(
  "getTopSellingProductsData",
  async (param, thunkAPI) => {
    const res = await getTopSellingProducts(param);
    console.log("getTopSellingProductsData", res);

    return res;
  }
);

export const getTableSaleAmtDataByMonthMultiBranch = createAsyncThunk(
  "getTableSaleAmtDataByMonthMultiBranch",
  async (param, thunkAPI) => {
    const res = await getOrderSummaryAnalysisMultiBranchApi(param);
    console.log("getTableSaleAmtDataByMonthMultiBranch", res);

    return { details: res?.details, type: param?.type };
  }
);

export const getSaleAmtDataByYearMultiBranch = createAsyncThunk(
  "getSaleAmtDataByYearMultiBranch",
  async (param, thunkAPI) => {
    const res = await getOrderSummaryAnalysisMultiBranchApi(param);
    console.log("getSaleAmtDataByYearMultiBranch", res);

    return res;
  }
);
export const getOrderReportByCityDataMB = createAsyncThunk(
  "getOrderReportByCityDataMB",
  async (param, thunkAPI) => {
    const res = await getOrderReportByCityMultiBranchApi(param);
    console.log("getOrderReportByCity", res);

    return res;
  }
);

export const getOrderReportAvgDataMB = createAsyncThunk(
  "getOrderReportAvgDataMB",
  async (param, thunkAPI) => {
    const res = await getOrderReportAvgMultiBranchApi(param);
    console.log("getOrderReportAvgDataMB", res);

    return res;
  }
);

export const getOrderReportByTypeYearData = createAsyncThunk(
  "getOrderReportByTypeYearData",
  async (param, thunkAPI) => {
    const res = await getOrderReportByType(param);
    console.log("getOrderReportByTypeYearData", res);

    return res;
  }
);

export const getOrderReportByDaysDataMultiBranch = createAsyncThunk(
  "getOrderReportByDaysDataMultiBranch",
  async (param, thunkAPI) => {
    const res = await getOrderSummaryAnalysisMultiBranchApi(param);
    console.log("getOrderReportByDaysDataMultiBranch", res);

    return res;
  }
);

export const multiBranchOrderSummary = createSlice({
  name: "multiBranchOrderSummary",
  initialState,
  reducers: {
    clearMultiBranchSummaryData: (state) => {
      console.log("HITTTT_BUG____02");
      
      state.summaryCountMultiBranch = null;
    },
  },
  extraReducers: {
    //Get Summary Count
    [getSummaryMultiBranch.pending]: (state) => {
      state.summaryCountLoader = true;
    },
    [getSummaryMultiBranch.fulfilled]: (state, { payload }) => {
      state.summaryCountMultiBranch = payload?.details;
      state.summaryCountLoader = false;
    },
    [getSummaryMultiBranch.rejected]: (state, { payload }) => {
      state.summaryCountLoader = false;
      state.summaryCountMultiBranch = null;
    },

    //TopSelling Products
    [getTopSellingProductsData.pending]: (state) => {
      state.topSellingProductsLoader = true;
      state.topSellingProducts = null;
    },
    [getTopSellingProductsData.fulfilled]: (state, { payload }) => {
      state.topSellingProducts = payload?.details;
      state.topSellingProductsLoader = false;
    },
    [getTopSellingProductsData.rejected]: (state, { payload }) => {
      state.topSellingProductsLoader = false;
      state.topSellingProducts = null;
    },

    //Table Month Data
    [getTableSaleAmtDataByMonthMultiBranch.pending]: (state) => {
      state.orderSaleAmtTableMonthDataMBLoader = true;
      state.orderSaleAmtTableMonthDataMB = null;
    },
    [getTableSaleAmtDataByMonthMultiBranch.fulfilled]: (state, { payload }) => {
      // state.orderSaleAmtTableMonthDataMB =
      //   payload?.details?.length > 0
      //     ? payload?.type === "year"
      //       ? transformSalesData(payload?.details)
      //       : transformDateRangeSalesData(payload?.details)
      //     : [];
      state.orderSaleAmtTableMonthDataMB =
              payload?.details?.length > 0
                ? payload?.type === "year"
                  ? transformSalesData(payload?.details)
                  : payload?.type === "month"
                  ? transformDateRangeSalesData(payload?.details)
                  : transformDateRangeSalesDataByDay(payload?.details)
                : [];
      state.orderSaleAmtTableMonthDataMBLoader = false;
    },
    [getTableSaleAmtDataByMonthMultiBranch.rejected]: (state, { payload }) => {
      state.orderSaleAmtTableMonthDataMBLoader = false;
      state.orderSaleAmtTableMonthDataMB = null;
    },

    //Year Data
    [getSaleAmtDataByYearMultiBranch.pending]: (state) => {
      state.orderSaleAmtYearDataMultiBranchLoader = true;
      state.orderSaleAmtYearDataMultiBranch = null;
    },
    [getSaleAmtDataByYearMultiBranch.fulfilled]: (state, { payload }) => {
      state.orderSaleAmtYearDataMultiBranch = payload?.details;
      state.orderSaleAmtYearDataMultiBranchLoader = false;
    },
    [getSaleAmtDataByYearMultiBranch.rejected]: (state, { payload }) => {
      state.orderSaleAmtYearDataMultiBranchLoader = false;
      state.orderSaleAmtYearDataMultiBranch = null;
    },

    //Order Report By City
    [getOrderReportByCityDataMB.pending]: (state) => {
      state.orderReportByCityMBLoader = true;
      state.orderReportByCityMB = null;
    },
    [getOrderReportByCityDataMB.fulfilled]: (state, { payload }) => {
      state.orderReportByCityMB = payload?.details;
      state.orderReportByCityMBLoader = false;
    },
    [getOrderReportByCityDataMB.rejected]: (state, { payload }) => {
      state.orderReportByCityMBLoader = false;
      state.orderReportByCityMB = null;
    },

    //Order Report By Type
    [getOrderReportByTypeYearData.pending]: (state) => {
      state.orderSalesByTypeYearLoader = true;
      state.orderSalesByTypeYear = null;
    },
    [getOrderReportByTypeYearData.fulfilled]: (state, { payload }) => {
      state.orderSalesByTypeYear = payload?.details;
      state.orderSalesByTypeYearLoader = false;
    },
    [getOrderReportByTypeYearData.rejected]: (state, { payload }) => {
      state.orderSalesByTypeYearLoader = false;
      state.orderSalesByTypeYear = null;
    },

    //Order Report Avg
    [getOrderReportAvgDataMB.pending]: (state) => {
      state.orderReportAvgMBLoader = true;
      state.orderReportAvgMB = null;
    },
    [getOrderReportAvgDataMB.fulfilled]: (state, { payload }) => {
      state.orderReportAvgMB = payload?.details?.[0] || [];
      state.orderReportAvgMBLoader = false;
    },
    [getOrderReportAvgDataMB.rejected]: (state, { payload }) => {
      state.orderReportAvgMBLoader = false;
      state.orderReportAvgMB = null;
    },

    //Report Days Data
    [getOrderReportByDaysDataMultiBranch.pending]: (state) => {
      state.orderReportByDaysMBLoader = true;
      state.orderReportByDaysMB = null;
    },
    [getOrderReportByDaysDataMultiBranch.fulfilled]: (state, { payload }) => {
      state.orderReportByDaysMB = payload?.details
        ? formatDaysTimePeriod(payload?.details)
        : [];
      state.orderReportByDaysMBLoader = false;
    },
    [getOrderReportByDaysDataMultiBranch.rejected]: (state, { payload }) => {
      state.orderReportByDaysMBLoader = false;
      state.orderReportByDaysMB = null;
    },
  },
});

export const { clearMultiBranchSummaryData } = multiBranchOrderSummary.actions;
export const multiBranchOrderSummaryReducer = multiBranchOrderSummary.reducer;
